import { isArray } from 'util';
import { TheoreticalMachine } from '../theoretical-machine';

export class TheoreticalMachineBuilder {
  static fromJson(json) {
    return (json)
      ? new TheoreticalMachine(
        json.hash,
        json.code,
        json.name,
        json.description,
        json.workingModelGroupHash,
        json.active,
        TheoreticalMachineBuilder.fromList(json.escalation),
        // Sin construir: hacerlo obligaria a importar ModelBuilder, que a su vez
        // construye maquinas teoricas. Solo se leen hash y nombre, que el JSON ya trae.
        json.models || []
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(TheoreticalMachineBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/theoretical-machine.builder.ts